import api from 'utils/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contentexpress/configuration/FETCH_REQUEST'
const FETCH_SUCCESS = 'contentexpress/configuration/FETCH_SUCCESS'
const FETCH_FAILURE = 'contentexpress/configuration/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  failures: 0,
  loaded: false,
  loading: false,
  result: {},
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadConfiguration(key = 'contentexpress', options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/utilities/configurations/${key}`, options)
      .then(({ data }) => {
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        failures: 0,
        loaded: true,
        loading: false,
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors,
        failures: state.failures + 1,
        loaded: false,
        loading: false,
      }
    default:
      return state
  }
}
